import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import { ModalTitle } from 'components/Modal'
import { ScenarioHaltConfirmationModal } from 'components/scenarios/detail/ScenarioActions'
import { getRunStage } from 'components/scenarios/utils'
import theme from 'theme'
import { omit } from 'utils/obj'

export default function NewCompletedScenariosNotifications({
  newCompletedScenarios = {},
  setNewCompletedScenarios
}) {
  const newNotifications = Object.entries(newCompletedScenarios).filter(
    ([, values]) => values.notificationStatus === 'new'
  )

  return (
    <div>
      {newNotifications.map(([notificationKey, notificationValues], index) => {
        return (
          <ScenarioHaltConfirmationModal
            key={`confirmation-modal-for-${notificationKey}`}
            haltConfirmationOpen
            isCompletedNotification
            confirmButtonType="primary"
            confirmText="Save"
            doFetch={() => true}
            hideOverlay={index > 0}
            scenarioId={notificationValues?.runInfo?.scenario_id}
            selectedRun={notificationValues?.runInfo}
            setDisableButton={() => true}
            setHaltConfirmationOpen={() =>
              setNewCompletedScenarios(
                omit(newCompletedScenarios, notificationKey)
              )
            }
            shouldCloseOnOverlayClick={false}
            title={
              <ModalTitle
                css={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                Scenario Completed
                <Text
                  as="small"
                  color="medium"
                  css={{
                    fontSize: theme.fontSizes[1],
                    marginTop: theme.space[2]
                  }}
                >
                  <strong>
                    {notificationValues?.runInfo?.name || 'Your scenario'}
                  </strong>{' '}
                  has {getRunStage(notificationValues?.runInfo)}
                </Text>
              </ModalTitle>
            }
          />
        )
      })}
    </div>
  )
}

NewCompletedScenariosNotifications.propTypes = {
  newCompletedScenarios: PropTypes.object,
  setNewCompletedScenarios: PropTypes.func
}
